import React from "react"
import { TestService } from "../service/TestService"


export default function TestPage() {


    function creatPostTest() {

        // axios.post("http://localhost:8888/test/connection").then(response => {
        //     console.log(response.data)
        // })
    
        TestService.testConnectionBackend().then(response => {

            console.log(response.data)

        }).catch(error => {
            console.log(error);
        })
    }
    return (
        <button onClick={() => creatPostTest()}>Test connection!</button>
    )
}